import { hasAnyAccessPermission, canViewOtherUser, isViewingSelf } from './utils';
import { isEmployee, isManagerOrAdmin, isSuperAdmin } from './userTypes';
import {
  PLATFORM_PROFILE_INFO,
  RECORD_ADDITIONAL_INFO,
  RECORD_PERSONAL_INFO,
  RECORD_PRIVATE_INFO,
  PERMISSION_VIEW_AND_EDIT,
} from './constants';
import { canEditPlatformArea, canViewPlatformArea } from './platformVisibility';

const RECORD_VISIBILITY = [RECORD_ADDITIONAL_INFO, RECORD_PERSONAL_INFO, RECORD_PRIVATE_INFO];

const isRecordPermission = (value) => {
  return RECORD_VISIBILITY.includes(value);
};

const hasEmployeeRecordVisibility = (user) => Boolean(user.userRole?.permissions?.employeeRecordVisibility);

const hasOwnInfoVisibility = (user) => Boolean(user.userRole?.permissions?.ownInfoVisibility);

const canViewEmployeeRecord = (area, user) =>
  hasAnyAccessPermission(user.userRole?.permissions?.employeeRecordVisibility[area]);

const canViewOwnInfo = (area, user) => hasAnyAccessPermission(user.userRole?.permissions?.ownInfoVisibility[area]);

export const canEditEmployeeRecord = (area, user) =>
  isRecordPermission(area) && user.userRole?.permissions?.employeeRecordVisibility[area] === PERMISSION_VIEW_AND_EDIT;

export const canEditOwnInfo = (area, user) =>
  isRecordPermission(area) && user.userRole?.permissions?.ownInfoVisibility[area] === PERMISSION_VIEW_AND_EDIT;

const canViewOtherUserRecord = (user, employee) =>
  canViewOtherUser(user, employee) && hasEmployeeRecordVisibility(user);

export const canViewEmployeeInfo = (area, user, employee = null) => {
  if (isSuperAdmin(user)) return true;
  if (area === PLATFORM_PROFILE_INFO) {
    return canViewPlatformArea(PLATFORM_PROFILE_INFO, user, employee);
  }
  // If viewing self, no employee or employee id is same id
  if (isViewingSelf(user, employee)) {
    if (isEmployee(user) && hasEmployeeRecordVisibility(user)) {
      return canViewEmployeeRecord(area, user);
    }
    if (isManagerOrAdmin(user) && hasOwnInfoVisibility(user)) {
      // Managers and Admins use own info visibility
      return canViewOwnInfo(area, user);
    }
  }
  if (canViewOtherUserRecord(user, employee)) {
    // Managers and Admins looking at other users must have relation to user and use platform visibility
    return canViewEmployeeRecord(area, user);
  }
  return false;
};

export const canEditEmployeeInfo = (area, loggedInUser, employee = null) => {
  if (isSuperAdmin(loggedInUser)) return true;
  if (area === PLATFORM_PROFILE_INFO) {
    return canEditPlatformArea(PLATFORM_PROFILE_INFO, loggedInUser, employee);
  }

  // If viewing self, no employee or employee id is same id
  if (isViewingSelf(loggedInUser, employee)) {
    if (isEmployee(loggedInUser) && hasEmployeeRecordVisibility(loggedInUser)) {
      return canEditEmployeeRecord(area, loggedInUser);
    }
    if (isManagerOrAdmin(loggedInUser) && hasOwnInfoVisibility(loggedInUser)) {
      // Managers and Admins use own info visibility
      return canEditOwnInfo(area, loggedInUser);
    }
  }
  if (canViewOtherUserRecord(loggedInUser, employee)) {
    // Managers and Admins looking at other users must have relation to user and use platform visibility
    return canEditEmployeeRecord(area, loggedInUser);
  }
  return false;
};
